import React, { Component } from 'react';
import UiKit                from '../../../uikit';

class CloseButton extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    render() {
        let { onClose } = this.props;
        return (
            <div className="marketkit-toast-close-button">
                <UiKit.Icon
                    icon        = 'line-close'
                    onClick     = { () => onClose() }
                />
            </div>
        )
    }
}

export default CloseButton;